import React from 'react'

import { ZariContext } from '_zari/context'

import { CodigosTransaccionesConstant } from 'constants/index'

import { Portlet, Table } from '_zari/core'

import * as UsuariosService from 'services/usuario.service'

const tableHeaderRows = [{ label: 'ESTABLECIMIENTO' }, { label: 'USUARIO' }, { label: 'SERIES' }]

const portletBreadcrumbs = [
  { name: 'Usuarios', path: `/${CodigosTransaccionesConstant.USUARIOS_LISTA}` },
  { name: 'Informe series' }
]

const ReporteSeriesPage = () => {
  const __zariContext = React.useContext(ZariContext)

  const [listaItems, setListaItems] = React.useState([])

  React.useEffect(() => {
    UsuariosService.obtenerInfoSedesSeries()
      .then(({ data }) => {
        setListaItems(data)
      })

      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }, [__zariContext])

  const rowTemplate = React.useCallback(
    (row, k) => (
      <Table.Row hover key={k}>
        <Table.Cell>{row.sede || '--'}</Table.Cell>
        <Table.Cell>{row.usuario || '--'}</Table.Cell>
        <Table.Cell>{row.series || '--'}</Table.Cell>
      </Table.Row>
    ),
    []
  )

  return (
    <>
      <Portlet>
        <Portlet.Header title='USUARIOS' breadcrumbs={portletBreadcrumbs} />
        <Portlet.Body>
          <Table headRows={tableHeaderRows} rowTemplate={rowTemplate} filas={listaItems} maxRowsShown={20} />
        </Portlet.Body>
      </Portlet>
    </>
  )
}

export default ReporteSeriesPage
